// import axios from "axios";
import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

export const AddEPO = async (formData) => {
  return axios.post(`${api.EXPENSE_PURCHASE_ORDER.ADD_EPO}`, formData);
};

export const GetEpoList = async (data) => {
  return axios.post(`${api.EXPENSE_PURCHASE_ORDER.MPC_EPO_VIEWER}`, data);
};

export const GetYourMPCVote = async (data) => {
  return axios.post(`${api.EXPENSE_PURCHASE_ORDER.MPC_YOUR_VOTE}`, data);
};
export const GetAllMPCVote = async (data) => {
  return axios.post(`${api.EXPENSE_PURCHASE_ORDER.MPC_ALL_VOTE}`, data);
};

export const GetSubordinatesEPOs = async (data) => {
  return axios.post(`${api.EXPENSE_PURCHASE_ORDER.SUBORDINATE_EPO_LIST}`, data);
};

export const GetApprovalListEPOs = async (data) => {
  return axios.post(`${api.EXPENSE_PURCHASE_ORDER.APPROVAL_LIST_EPO}`, data);
};

export const GetEPODetailById = async (epoId) => {
  return axios.get(
    `${api.EXPENSE_PURCHASE_ORDER.EPO_DETAIL_BY_ID}?EpoNo=${epoId}`
  );
};

export const DownloadPdfEpo = async (epoId) => {
  return axios.get(
    `${api.EXPENSE_PURCHASE_ORDER.DOWNLOAD_PDF_EPO}?EpoNo=${epoId}`
  );
};

export const GetAllVendorOrEmployeeDetailsByName = async (data) => {
  return axios.get(`${api.EXPENSE_PURCHASE_ORDER.GET_ALL_VENDOR_OR_EMPLOYEE_DETAILS_BY_NAME}?Name=${data.name}&IsEmployee=${data.isEmployee}`)
}

export const GetMPCVoteList = async (epoId) => {
  return axios.get(
    `${api.EXPENSE_PURCHASE_ORDER.GET_MPC_VOTE_LIST}?EpoId=${epoId}`
  );
};
// Common dropdowns API for Create Epo
export const GetAllEpoDropdown = async () => {
  return await axios.get(`${api.EXPENSE_PURCHASE_ORDER.CREATE_EPO_DROPDOWN}`);
};

export const GetEpoModulesCounts = async () => {
  return await axios.get(`${api.EXPENSE_PURCHASE_ORDER.GET_EPO_MODULES_COUNTS}`)
}

export const GetUserLimit = async () => {
  return await axios.get(`${api.EXPENSE_PURCHASE_ORDER.GET_USER_LIMIT}`);
};

export const AddEpoVendor = async (data) => {
  return await axios.post(`${api.EXPENSE_PURCHASE_ORDER.ADD_VENDOR}`, data);
};

//Void Api for My EPO Section
export const SetEPOVoid = async (data) => {
  return await axios.post(`${api.EXPENSE_PURCHASE_ORDER.VOID_EPO_BY_ID}`, data);
};

//Accept or Denied
export const ApproveOrDeniedEPO = async (epoId, IsApprove) => {
  return await axios.post(
    `${api.EXPENSE_PURCHASE_ORDER.APPROVAL_OR_DENIED_EPO}?EpoId=${epoId}&IsApprove=${IsApprove}`
  );
};
export const ApproveOrDeniedEPOViaEmail = async (epoId, IsApprove,UserId) => {
  return await axios.post(
    `${api.EXPENSE_PURCHASE_ORDER.APPROVAL_OR_DENIED_EPO_VIA_MAIL}?EpoId=${epoId}&IsApprove=${IsApprove}&UserId=${UserId}`
  );
};
//mock api
export const GetPaymentList = async () => {
  //TODO: Call API
  return axios.get(`${process.env.PUBLIC_URL}/paymentList.json`);
};

export const GetCurrencyValue = async (data) => {
  return await axios.get(`${api.EXPENSE_PURCHASE_ORDER.GET_CURRENCY_VALUE}?currencySymbol=${data}`);
}
